import React, { useEffect, useRef, useState } from "react";
import { Box, Grid, Link, List, ListItem, Typography } from "@mui/material";
import LangSelect from "../../components/language/LanguageSelect";
import { useTranslation } from "react-i18next";
import TermsandConditions from "../../userAuth/Login/termsandconditions";

const AfterLoginFooter: React.FC = () => {
  const { t } = useTranslation();
  const [footervisible, setIsFooterVisible] = useState(false);

  const [openterms, setOpenterms] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalType, setModalType] = useState<"terms" | "privacy">("terms");

  const handleopenterms = (type: "terms" | "privacy") => {
    setModalType(type);
    setModalTitle(
      type === "terms" ? t("terms_conditions") : t("privacy_policy")
    );
    setOpenterms(true);
  };

  const handlecloseterms = () => {
    setOpenterms(false);
  };
  const lastScrollY = useRef(window.scrollY); // Use ref to store last scroll position

  useEffect(() => {
    const handleScroll = (event: WheelEvent) => {
      const currentScrollY = window.scrollY;

      if (event.deltaY > 0) {
        //  Scrolling DOWN → Show footer
        setIsFooterVisible(true);
      } else if (event.deltaY < 0) {
        // Scrolling UP → Hide footer
        setIsFooterVisible(false);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("wheel", handleScroll); // Detects mouse wheel movement

    return () => {
      window.removeEventListener("wheel", handleScroll);
    };
  }, []);

  return (
    <Box
      sx={{
        display: "block",
        backgroundColor: "#151414",
        color: "#878787",
        position: "fixed", // Footer remains fixed at the bottom
        bottom: 0,
        left: 0, // Ensures it doesn't shift
        width: "100vw", // Keeps it full-width regardless of sidebar
        zIndex: 1301, // Keeps it above all content
        borderTop: "1px solid #e0e0e0",
        transition: "transform 0.4s ease-in-out, opacity 0.4s",
        transform: footervisible ? "translateY(0)" : "translateY(100%)",
        opacity: footervisible ? 1 : 0,
      }}
    >
      <Box
        sx={{
          backgroundColor: "#f7f7f7",
        }}
      >
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
        >
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            lg={4}
            xl={4}
            sx={{
              textAlign: { xs: "center", sm: "left" },
              mb: { xs: 1, sm: 0 },
            }}
          >
            <List
              sx={{
                display: "flex",
                justifyContent: { xs: "center", lg: "start" },
                p: 0,
              }}
            >
              <ListItem sx={{ width: "auto", gap: 2, p: 1 }}>
                <Link
                  href="#"
                  sx={{
                    color: "#878787",
                    fontSize: { xs: 10, sm: 12, md: 12, lg: 13, xl: 13 },
                    "&:hover": { color: "#1976d2" },
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    handleopenterms("terms");
                  }}
                >
                  {t("terms_conditions")}
                </Link>
              </ListItem>
              <ListItem sx={{ width: "auto", p: 1 }}>
                <Link
                  href="#"
                  sx={{
                    color: "#878787",
                    fontSize: { xs: 10, sm: 12, md: 12, lg: 13, xl: 13 },
                    "&:hover": { color: "#1976d2" },
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    handleopenterms("privacy");
                  }}
                >
                  {t("privacy_policy")}
                </Link>
              </ListItem>
            </List>
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
            <Typography
              variant="body2"
              sx={{
                textAlign: { xs: "center" },
                fontSize: { xs: 10, sm: 12, md: 12, lg: 13, xl: 13 },
                color: "#878787",
              }}
            >
              {t("copyright")} &copy; {new Date().getFullYear()},{" "}
              {t("all_rights_reserved")}{" "}
              <Link
                // href="https://clinicalvisuals.com/"
                sx={{ color: "#ff5e14", textDecoration: "none" }}
              >
                {t("clinical_visuals")}
              </Link>
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            lg={4}
            xl={4}
            sx={{
              justifyContent: { xs: "center", sm: "end", lg: "end", xl: "end" },
              pr: "2%",
            }}
          >
            <Box
              sx={{
                justifyItems: { xs: "center", lg: "end" },
                width: { xs: "100%", sm: "100%" },
                height: { xs: "40px" },
              }}
            >
              <List sx={{ display: "flex", gap: 2, p: 0 }}>
                <ListItem sx={{ width: "auto", p: 0 }}>
                  <LangSelect />
                </ListItem>
              </List>
            </Box>
          </Grid>
        </Grid>
        <TermsandConditions
          open={openterms}
          handleCloseTerms={handlecloseterms}
          title={modalTitle}
          type={modalType} // Pass 'type' prop (required in API fetch)
        />
      </Box>
    </Box>

   
  );
};

export default AfterLoginFooter;

